//layouts
import Configs from "views/Configs";
import Inventory from "views/Inventory";
import AddInventory from "views/Inventory/AddInventory";
import EditInventory from "views/Inventory/EditInventory";
import ServerProducts from "views/ServerProducts";
import ServerProductsQuotes from "views/ServerProductsQuotes";
import AddServerProduct from "views/ServerProducts/AddServerProduct";
import EditServerProduct from "views/ServerProducts/EditServerProduct";
import Companies from "views/Companies";
import Orders from "views/Orders";
import AddOrder from "views/Orders/AddOrder";
import CreditNotes from "views/CreditNotes";
import Quotes from "views/Quotes";
import AddQuote from "views/Quotes/AddQuote";
import Countries from "views/Countries";
import EmailTemplates from "views/EmailTemplates";
import Categories from "views/Categories";
import BDMs from "views/BDMs";
import Reminders from "views/Reminders/ReminderTypes";
import ReminderTypes from "views/Reminders/ReminderTypes";
import ReminderHistory from "views/Reminders/ReminderHistory";
import UpcomingReminders from "views/Reminders/UpcomingReminders";
import CustomReminders from "views/Reminders/CustomReminders";
import Icon from "@mui/material/Icon";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CategoryIcon from "@mui/icons-material/Category";
import SettingsIcon from "@mui/icons-material/Settings";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import UpdateIcon from "@mui/icons-material/Update";
import RestoreIcon from "@mui/icons-material/Restore";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SendEmail from "views/EmailHistory/SendEmail";
import { EmailOutlined, MarkEmailRead, MarkEmailUnreadTwoTone } from "@mui/icons-material";
import EmailHistory from "views/EmailHistory";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import StorageIcon from '@mui/icons-material/Storage';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

export const userRoutes = [
  {
    type: "collapse",
    name: "Configs",
    key: "configs",
    icon: <SettingsIcon fontSize="small" />,
    route: "/user/configs",
    component: Configs,
    visible: true,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Inventory",
    key: "inventory",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/user/inventory",
    component: Inventory,
    visible: true,
    allowBdm: false,
    nestedChild: true,
    children: [
      {
        type: "collapse",
        name: "Software Products",
        route: "/user/inventory",
        key: "software-products",
        component: Inventory,
        icon: <AddShoppingCartIcon fontSize="small" />,
      },
      {
        type: "collapse",
        name: "Server Products",
        route: "/user/server-products",
        key: "server-products",
        component: ServerProducts,
        icon: <StorageIcon fontSize="small" />,
      },
      {
        type: "collapse",
        name: "Server Products Quotes",
        route: "/user/server-products-quotes",
        key: "server-products-quotes",
        component: ServerProductsQuotes,
        icon: <RequestQuoteIcon fontSize="small" />,
      }
    ],
  },
  {
    type: "collapse",
    name: "Add Product",
    key: "add-product",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/user/add-inventory",
    component: AddInventory,
    invisible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Edit Inventory",
    key: "edit-inventory",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/user/:id/edit-inventory",
    component: EditInventory,
    invisible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Server Products",
    key: "server-products-route",
    icon: <StorageIcon fontSize="small" />,
    route: "/user/server-products",
    component: ServerProducts,
    visible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Server Products Quotes",
    key: "server-products-quotes",
    icon: <StorageIcon fontSize="small" />,
    route: "/user/server-products-quotes",
    component: ServerProductsQuotes,
    visible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Add Server Product",
    key: "add-server-product",
    icon: <StorageIcon fontSize="small" />,
    route: "/user/add-server-product",
    component: AddServerProduct,
    invisible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Edit Server Product",
    key: "edit-server-product",
    icon: <StorageIcon fontSize="small" />,
    route: "/user/:id/edit-server-product",
    component: EditServerProduct,
    invisible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Categories",
    key: "categories",
    icon: <CategoryIcon fontSize="small" />,
    route: "/user/categories",
    component: Categories,
    visible: true,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Companies",
    key: "resellers",
    icon: <Icon fontSize="small">storefront</Icon>,
    route: "/user/companies",
    component: Companies,
    visible: true,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    icon: <AttachMoneyIcon fontSize="small" />,
    route: "/user/orders",
    component: Orders,
    visible: true,
    allowBdm: true,
  },
  {
    type: "collapse",
    name: "Add Order",
    key: "add-order",
    icon: <AttachMoneyIcon fontSize="small" />,
    route: "/user/add-order",
    component: AddOrder,
    invisible: false,
    allowBdm: true,
  },
  {
    type: "collapse",
    name: "Quotes",
    key: "quotes",
    icon: <RequestQuoteIcon fontSize="small" />,
    route: "/user/quotes",
    component: Quotes,
    visible: true,
    allowBdm: true,
  },
  {
    type: "collapse",
    name: "Add Quote",
    key: "add-quote",
    icon: <RequestQuoteIcon fontSize="small" />,
    route: "/user/add-quote",
    component: AddQuote,
    invisible: false,
    allowBdm: true,
  },
  {
    type: "collapse",
    name: "Credit Notes",
    key: "credit-notes",
    icon: <CreditScoreIcon fontSize="small" />,
    route: "/user/credit-notes",
    component: CreditNotes,
    visible: true,
    allowBdm: true,
  },
  {
    type: "collapse",
    name: "BDM",
    key: "bdm",
    icon: <SupervisedUserCircleIcon fontSize="small" />,
    route: "/user/bdm",
    component: BDMs,
    visible: true,
    allowBdm: false,
  },

  {
    type: "collapse",
    name: "Reminders",
    key: "bdm",
    icon: <AccessAlarmIcon fontSize="small" />,
    route: "/user/reminders",
    component: Reminders,
    visible: true,
    allowBdm: false,
    nestedChild: true,
    children: [
      {
        type: "collapse",
        name: "Reminder Types",
        route: "/user/reminder-types",
        key: "reminder-types",
        component: ReminderTypes,
        icon: <SettingsIcon fontSize="small" />,
      },
      {
        type: "collapse",
        name: "Upcoming Reminders",
        route: "/user/reminders-upcoming",
        key: "upcoming-reminders",
        component: UpcomingReminders,
        icon: <UpdateIcon fontSize="small" />,
      },
      {
        type: "collapse",
        name: "Reminder History",
        route: "/user/reminders-history",
        key: "reminder-history",
        component: ReminderHistory,
        icon: <RestoreIcon fontSize="small" />,
      },
      {
        type: "collapse",
        name: "Custom Reminders",
        route: "/user/reminders-custom",
        key: "custom-reminders",
        component: CustomReminders,
        icon: <MoreTimeIcon fontSize="small" />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Reminder Types",
    key: "reminder-types",
    icon: <SettingsIcon fontSize="small" />,
    route: "/user/reminder-types",
    component: ReminderTypes,
    visible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Upcoming Reminders",
    key: "upcoming-reminders",
    icon: <UpdateIcon fontSize="small" />,
    route: "/user/reminders-upcoming",
    component: UpcomingReminders,
    visible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Reminder History",
    key: "reminder-history",
    icon: <RestoreIcon fontSize="small" />,
    route: "/user/reminders-history",
    component: ReminderHistory,
    visible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Custom Reminders",
    key: "custom-reminders",
    icon: <MoreTimeIcon fontSize="small" />,
    route: "/user/reminders-custom",
    component: CustomReminders,
    visible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Countries",
    key: "countries",
    icon: <Icon fontSize="small">public</Icon>,
    route: "/user/countries",
    component: Countries,
    visible: true,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Email Templates",
    key: "email_templates",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/user/email_templates",
    component: EmailTemplates,
    visible: true,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Send Email",
    key: "sendEmailNav",
    icon: <EmailOutlined fontSize="small" />,
    route: "/user/email-history",
    component: EmailHistory,
    visible: true,
    allowBdm: false,
    nestedChild: true,
    children: [
      {
        type: "collapse",
        name: "Email History",
        key: "email-history",
        icon: <MarkEmailRead fontSize="small" />,
        route: "/user/email-history",
        component: EmailHistory,
        visible: true,
        allowBdm: false,
      },
      {
        type: "collapse",
        name: "Send Email",
        key: "send-email",
        icon: <MarkEmailUnreadTwoTone fontSize="small" />,
        route: "/user/send-email",
        component: SendEmail,
        visible: true,
        allowBdm: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Email History",
    key: "email-history",
    icon: <MarkEmailRead fontSize="small" />,
    route: "/user/email-history",
    component: EmailHistory,
    visible: false,
    allowBdm: false,
  },
  {
    type: "collapse",
    name: "Send Email",
    key: "send-email",
    icon: <MarkEmailUnreadTwoTone fontSize="small" />,
    route: "/user/send-email",
    component: SendEmail,
    visible: false,
    allowBdm: true,
  },
];
